<div class="hdwf">
  <div class="hdwf-header">
    <h2 class="hdwf-title">Filters</h2>
    <button type="button" class="hdwf-close" (click)="cancel()" aria-label="Close">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>

  <div class="hdwf-body">


    <div class="hdwf-section hdwf-section-vendor">
      <div class="hdwf-section-title">Vendor</div>
      <p class="hdwf-muted hdwf-muted-inline" *ngIf="selectedDepartmentName">
        Department: {{ selectedDepartmentName }}
      </p>
      <div *ngIf="vendorsLoading" class="hdwf-muted">Loading vendors…</div>
      <ng-container *ngIf="!vendorsLoading">
        <p *ngIf="vendorsError" class="hdwf-vendor-offline">
          {{ vendorsError }} Other filters still work — choose Apply.
        </p>
        <div class="hdwf-vendor-combo">
          <div class="hr-combobox">
            <div class="hr-combobox-trigger" (click)="openVendor()" [class.hr-trigger-open]="vendorOpen">
              <span class="hr-trigger-text">{{ vendorTriggerText }}</span>
              <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
            </div>
            <div class="hr-combobox-panel" *ngIf="vendorOpen">
              <div class="att-search-container">
                <input type="text" class="form-control att-search-input" placeholder="Search vendor"
                  [(ngModel)]="vendorQuery" (keyup)="filterVendors()" (mousedown)="$event.stopPropagation()" />
              </div>
              <div class="list_campus">
                <ul class="att-dropdown-item" (mousedown)="selectVendorClear(); $event.preventDefault()"
                  [class.att-item-selected]="selectedVendorId == null">
                  <li class="att-item-text">All vendors</li>
                  <li><i *ngIf="selectedVendorId == null" class="fa fa-check att-check-icon"></i></li>
                </ul>
                <ng-container *ngFor="let v of filteredVendorList">
                  <ul class="att-dropdown-item" (mousedown)="selectVendor(v); $event.preventDefault()"
                    [class.att-item-selected]="isVendorOptionSelected(v)">
                    <li class="att-item-text">{{ v.vendorName }}</li>
                    <li><i *ngIf="isVendorOptionSelected(v)" class="fa fa-check att-check-icon"></i></li>
                  </ul>
                </ng-container>
                <p *ngIf="!vendorsError && vendors.length === 0" class="hdwf-muted hdwf-muted-inline">
                  No vendors in list.
                </p>
                <p *ngIf="vendorsError" class="hdwf-muted hdwf-muted-inline">Vendor API unavailable — use All vendors.
                </p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="hdwf-section-title">Organization</div>
    <!-- Segment: multi-select All / School / College (same `collegeTypes` as before) -->
    <div class="hdwf-segment-card" role="group" aria-label="Segment">
      <button type="button" class="hdwf-segment-head" (click)="toggleSegmentSection()"
        [attr.aria-expanded]="segmentExpanded" aria-controls="hdwf-segment-panel">
        <span class="hdwf-segment-title">Segment</span>
        <i class="fa fa-chevron-up hdwf-segment-chevron" [class.hdwf-segment-chevron-collapsed]="!segmentExpanded"
          aria-hidden="true"></i>
      </button>
      <div id="hdwf-segment-panel" class="hdwf-segment-panel" *ngIf="segmentExpanded">
        <label class="hdwf-segment-item">
          <input type="checkbox" [checked]="segmentAllChecked" [indeterminate]="segmentAllIndeterminate"
            (change)="toggleSegmentAll()" />
          <span>All</span>
        </label>
        <label class="hdwf-segment-item">
          <input type="checkbox" [checked]="collegeTypes.includes('SCHOOL')" (change)="toggleCollegeType('SCHOOL')" />
          <span>School</span>
        </label>
        <label class="hdwf-segment-item">
          <input type="checkbox" [checked]="collegeTypes.includes('COLLEGE')" (change)="toggleCollegeType('COLLEGE')" />
          <span>College</span>
        </label>
      </div>
    </div>

    <!-- CampusType: multi-select All / Residential / DayScholar (same `boardingTypes` as before) -->
    <div class="hdwf-segment-card" role="group" aria-label="CampusType">
      <button type="button" class="hdwf-segment-head" (click)="toggleCampusTypeSection()"
        [attr.aria-expanded]="campusTypeExpanded" aria-controls="hdwf-campus-type-panel">
        <span class="hdwf-segment-title">Campus Type</span>
        <i class="fa fa-chevron-up hdwf-segment-chevron"
          [class.hdwf-segment-chevron-collapsed]="!campusTypeExpanded" aria-hidden="true"></i>
      </button>
      <div id="hdwf-campus-type-panel" class="hdwf-segment-panel" *ngIf="campusTypeExpanded">
        <label class="hdwf-segment-item">
          <input type="checkbox" [checked]="campusTypeAllChecked" [indeterminate]="campusTypeAllIndeterminate"
            (change)="toggleCampusTypeAll()" />
          <span>All</span>
        </label>
        <label class="hdwf-segment-item">
          <input type="checkbox" [checked]="boardingTypes.includes('RESIDENTIAL')"
            (change)="toggleBoarding('RESIDENTIAL')" />
          <span>Residential</span>
        </label>
        <label class="hdwf-segment-item">
          <input type="checkbox" [checked]="boardingTypes.includes('DAY_SCHOLAR')"
            (change)="toggleBoarding('DAY_SCHOLAR')" />
          <span>DayScholar</span>
        </label>
      </div>
    </div>

  </div>

  <div class="hdwf-footer">
    <button type="button" class="hdwf-btn hdwf-btn-ghost" (click)="cancel()">Cancel</button>
    <button type="button" class="hdwf-btn hdwf-btn-primary" (click)="apply()">Apply</button>
  </div>
</div>
